/**
 * @module mobileMenu
 */

module.exports = function() {
    const mobileMainMenu = document.getElementById( 'navbarMobileMainMenu' );
    const mainMenuNavigation = document.querySelector( '.main_menu__nav' );

    mobileMainMenu.addEventListener( 'shown.bs.collapse', () => {
        mainMenuNavigation.classList.add( 'slideout-menu-show' );
    } );

    mobileMainMenu.addEventListener( 'hide.bs.collapse', () => {
        setTimeout( () => {
            mainMenuNavigation.classList.remove( 'slideout-menu-show' );
        }, 250 );
    } );
}; // exports